import { Column } from "data/table.data";
import { Journal } from "models/journal.model";
import { convertCurrency } from "utils/converter";
import {
  ChipAppearance,
  renderChip,
  renderDateTime,
  renderJournalStatus
} from "utils/renderer";

// 공통 Table의 정렬(sortList)이 행 필드 기준이라, 화면에 보이는 값을 행에 미리 풀어 둔다
export interface JournalRow extends Journal {
  debitAccount: string;
  creditAccount: string;
  storeText: string;
  memoText: string;
  refsText: string;
  statusOrder: number; // 상태 열 정렬용
}

const SLIP_TYPE_CHIPS: Record<
  Journal["slipType"],
  { label: string; appearance: ChipAppearance }
> = {
  "3": {
    label: "대체",
    appearance: { color: "primary", variant: "filled", shape: "rounded" }
  },
  "1": {
    label: "출금",
    appearance: { color: "primary", variant: "outlined", shape: "rounded" }
  },
  "2": {
    label: "입금",
    appearance: { color: "white", variant: "outlined", shape: "square" }
  }
};

export const JOURNAL_COLS: Column[] = [
  {
    id: "makeDt",
    label: "일자",
    sorting: true,
    sx: { whiteSpace: "nowrap", fontSize: 14 }
  },
  {
    id: "slipType",
    label: "구분",
    sorting: true,
    renderer: (data: JournalRow) => {
      const chip = SLIP_TYPE_CHIPS[data.slipType];
      return chip ? renderChip(chip.label, chip.appearance) : "-";
    }
  },
  {
    id: "debitAccount",
    label: "차변 계정",
    sorting: true,
    sx: { width: 120, wordBreak: "keep-all", fontSize: 14 }
  },
  {
    id: "creditAccount",
    label: "대변 계정",
    sorting: true,
    sx: { width: 120, wordBreak: "keep-all", fontSize: 14 }
  },
  {
    id: "storeText",
    label: "거래처",
    sorting: true,
    sx: { width: 120, wordBreak: "break-all", fontSize: 14, fontWeight: 500 }
  },
  {
    id: "memoText",
    label: "적요",
    sorting: true,
    sx: { wordBreak: "break-all", fontSize: 14 }
  },
  {
    id: "totalDebit",
    label: "금액",
    sorting: true,
    renderer: (data: JournalRow) => convertCurrency(data.totalDebit),
    sx: { textAlign: "right" }
  },
  {
    id: "seperator",
    label: "|",
    renderer: () => "|",
    sx: { width: 4, textAlign: "center" }
  },
  {
    id: "refsText",
    label: "연결 원천",
    sorting: true,
    renderer: (data: JournalRow) => data.refsText || "-",
    sx: { fontSize: 14 }
  },
  {
    id: "statusOrder",
    label: "전송상태",
    sorting: true,
    renderer: (data: JournalRow) => renderJournalStatus(data)
  },
  {
    id: "newzenSentAt",
    label: "전송일시",
    sorting: true,
    renderer: (data: JournalRow) => renderDateTime(data.newzenSentAt),
    sx: { whiteSpace: "nowrap", textAlign: "right" }
  }
];
